import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';

interface SelfIssuedReceiptsListFilters {
  warehouseId?: string;
  creationDateFrom?: string;
  creationDateTo?: string;
  isApplicable?: boolean;
}

export const transformSelfIssuedReceiptsListFilters = ({
  selectedWarehouses,
  creationDateFrom,
  creationDateTo,
  isApplicable,
}: TableFilterType): SelfIssuedReceiptsListFilters => {
  return {
    warehouseId: selectedWarehouses?.value || undefined,
    creationDateFrom: getFilterServerFormatDate(creationDateFrom?.value),
    creationDateTo: getFilterServerFormatDate(creationDateTo?.value),
    isApplicable: isApplicable?.value === undefined ? undefined : isApplicable?.value === 'applicable',
  };
};
